module.exports = __webpack_public_path__ + "img/trees.ae376cc8.svg";